import { render, staticRenderFns } from "./horizontalTable.vue?vue&type=template&id=2f8333d9&scoped=true"
import script from "./horizontalTable.vue?vue&type=script&lang=js"
export * from "./horizontalTable.vue?vue&type=script&lang=js"
import style0 from "./horizontalTable.vue?vue&type=style&index=0&id=2f8333d9&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8333d9",
  null
  
)

export default component.exports